import React from "react";
import Meta from "../Meta";
import Hero from "../components/Hero";
import SectionRenderer from "../components/SectionRenderer";
import Loader from "../loader";
import { applyLang } from "../../../i18n";
import { t } from "@lingui/core/macro";
import { DEFAULT_HOME_SECTIONS, resolveImage } from "../utils";
import { readHeroSlides, readHomeSections } from "../compat";

export default function Home({ context, loading }) {
    const { org, config } = context;

    // readHeroSlides : nouveau format hero.slides en priorité, fallback legacy hero.carousel.
    const slides = readHeroSlides(config);
    const firstSlide = slides[0] ? applyLang(slides[0], context.lang) : null;
    const heroImage = firstSlide?.image ? resolveImage(firstSlide.image) : null;

    const description =
        firstSlide?.description ||
        config["meta.description"] ||
        org.description ||
        t`Bienvenue sur le site de ${org.name}`;

    // readHomeSections : home.sections en priorité, sinon defaults avec legacy disable.*
    const sections = readHomeSections(config, DEFAULT_HOME_SECTIONS);

    const jsonLd = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: org.name,
        url: org.BASE_WEB_URL || undefined,
        logo: org.logo ? resolveImage(org.logo) : undefined,
        address: org.adresse ? {
            "@type": "PostalAddress",
            streetAddress: org.adresse,
            addressLocality: org.ville,
        } : undefined,
    };

    return (
        <>
            <Meta
                context={context}
                title={org.name}
                description={description}
                image={heroImage}
                preloadImage={heroImage}
                jsonLd={jsonLd}
            />

            {loading && <Loader />}

            <Hero context={context} />

            {sections.map(s => (
                <SectionRenderer key={s.id} section={s} context={context} />
            ))}
        </>
    );
}
